import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  AUTH_RESET_PASSWORD_BEGIN,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAILURE,
  AUTH_RESET_PASSWORD_DISMISS_ERROR,
} from './constants';
import ApiService from '../../common/services/ApiService';

export function resetPassword(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: AUTH_RESET_PASSWORD_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.resetPassword(args).then(
        (res) => {
            dispatch({
              type: AUTH_RESET_PASSWORD_SUCCESS,
              data: res,
            });
            resolve(res);
          },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: AUTH_RESET_PASSWORD_FAILURE,
            data: { error: err.data },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissResetPasswordError() {
  return {
    type: AUTH_RESET_PASSWORD_DISMISS_ERROR,
  };
}

export function useResetPassword(params) {
  const dispatch = useDispatch();

  const { resetPasswordPending, resetPasswordError } = useSelector(
    state => ({
      resetPasswordPending: state.auth.resetPasswordPending,
      resetPasswordError: state.auth.resetPasswordError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(resetPassword(...args));
  }, [dispatch]);

  useEffect(() => {
    if (params) boundAction(...(params || []));
  }, [...(params || []), boundAction]); // eslint-disable-line

  const boundDismissError = useCallback(() => {
    return dispatch(dismissResetPasswordError());
  }, [dispatch]);

  return {
    resetPassword: boundAction,
    resetPasswordPending,
    resetPasswordError,
    dismissResetPasswordError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AUTH_RESET_PASSWORD_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        resetPasswordPending: true,
        resetPasswordError: null,
      };

    case AUTH_RESET_PASSWORD_SUCCESS:
      // The request is success
      return {
        ...state,
        resetPasswordPending: false,
        resetPasswordError: null,
      };

    case AUTH_RESET_PASSWORD_FAILURE:
      // The request is failed
      return {
        ...state,
        resetPasswordPending: false,
        resetPasswordError: action.data.error,
      };

    case AUTH_RESET_PASSWORD_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        resetPasswordError: null,
      };

    default:
      return state;
  }
}
